export const getKeycloakUrl = (): string | undefined => {
  const link = process.env.REACT_APP_KEYCLOAK_URL;
  return link;
};
export const getKeycloakRealm = (): string | undefined => {
  const link = process.env.REACT_APP_KEYCLOAK_REALM;
  return link;
};

export const getKeycloakClientId = (): string | undefined => {
  const link = process.env.REACT_APP_KEYCLOAK_CLIENT_ID;
  return link;
};

export const getNodeEnv = (): string | undefined => {
  const link = process.env.NODE_ENV;
  return link;
};

export const getApiHost = (): string | undefined => {
  const link = process.env.REACT_APP_API_HOST;
  return link;
};

export const useSsoSdkBypass = (): boolean => {
  const envBypass = process.env.REACT_APP_SSO_SDK_BYPASS?.toLowerCase() === 'true';
  const hostBypass =
    typeof window !== 'undefined' && window.location.hostname === 'cardio360.hml.gruponc.net.br';
  return envBypass || hostBypass;
};
